module.exports = __webpack_public_path__ + "static/media/wizard_2.3b828b45.png";